import { render, staticRenderFns } from "./ChallengeListHeader.vue?vue&type=template&id=c327af8c&"
import script from "./ChallengeListHeader.vue?vue&type=script&lang=js&"
export * from "./ChallengeListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports